import _get from "lodash-es/get";

import getAxios from "../../utils/axios";
import APIendpoints from "../../utils/constants/APIendpoints";
import actionTypes from "../actionTypes";

function requestProduct(requestBody, callBack ) {
  return (dispatch) => {
    dispatch({ type: actionTypes.REQUEST_PRODUCT_BEGIN });
    getAxios(true)
      .post(APIendpoints.requestProduct, requestBody)
      .then(() => {
        dispatch({
          type: actionTypes.REQUEST_PRODUCT_DONE,
        });

        if (typeof callBack === "function"){
          callBack(true)
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.REQUEST_PRODUCT_FAIL,
          error:  _get(
            err,
            ["response", "data", "error"],
            {}
          )
        });
      });
  };
}

export {
  requestProduct
}